import React, {useState} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import WizardPopupContext, {useCustomContext, wizardPopupAction} from "../WizardPopupContext";
import DropDown2 from "../../../Generic/dropDown2";

const WizardPopupEditGroupLeadFormStepSelect = (props) => {

  const {wizardPopupItem} = props;

  const {wizardPopupState, wizardPopupDispatch} = useCustomContext(WizardPopupContext);

  const {leadStep} = wizardPopupState;

  const [opened, setOpened] = useState(false);

  const changeInputValue = (property, newValue) => {
    wizardPopupDispatch({
      type: wizardPopupAction,
      payload: {
        [property]: newValue
      }
    })
  }

  const onSelect = (value) => {
    changeInputValue("leadStep", value);
    setOpened(false);
  }
  //
  // const onAddNew = (value) => {
  //   changeInputValue("leadStep", value)
  // }

  const defaultSteps = leadStep && (leadStep !== "Project") ? ["Project", leadStep] : ["Project"];

  // console.log("wizardPopupItem.wizardGroups", wizardPopupItem.wizardGroups);

  const allSteps = wizardPopupItem.wizardGroups
    .reduce((total, wizardGroup) => {
      if (wizardGroup.leadStep && !total.includes(wizardGroup.leadStep)) {
        total.push(wizardGroup.leadStep)
      }
      return total
    }, defaultSteps)
    .map(step => ({text: step, value: step}));

  return (
    <div className="wizard-popup__block-input">
      <span className="generic-popup-title">Lead Form Step</span>
      <div className={"fc-inst__select select2" + (opened ? " select2--active" : "")}>
        <div className="select2-value" onClick={() => setOpened(true)}>
          {leadStep}
        </div>
        {opened ? (
          <DropDown2 selected={leadStep}
                     items={allSteps}
                     onClickOutside={() => setOpened(false)}
                     onSelect={onSelect}
                     useVirtualizedList={false}
                     onAddNew={onSelect}
                     addNewItemName={"Step"}
                     alwaysShowAdd={true}
                     filter={false}/>
        ) : null}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardPopupGroup, wizardPopupItem, wizardPopupType} = store.wizardState;
  return {
    wizardPopupGroup,
    wizardPopupItem,
    wizardPopupType,
  };
};

export default injectIntl(
  connect(mapStateToProps)(WizardPopupEditGroupLeadFormStepSelect)
)
